export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-D-Nav-WEB-21e7a812d34ef5eb5d4ef3b12a320acb.png";